var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "table-toolbar" }, [
        _c("span", [
          _vm._v(
            _vm._s(_vm.$t("admins.adminsNumber")) +
              " " +
              _vm._s(_vm.groupsData.total) +
              " "
          )
        ]),
        _c(
          "div",
          { staticClass: "table-toolbar__group" },
          [
            _c("TableSearch", { attrs: { "data-source": _vm.groupsData } }),
            _c("TableLimitSelector", {
              attrs: { "data-source": _vm.groupsData }
            })
          ],
          1
        )
      ]),
      _c("Table", {
        attrs: {
          columns: _vm.notificationsColumns,
          "data-source": _vm.groupsData
        },
        on: { clickRow: () => {} }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }